import { render, staticRenderFns } from "./CreateTextFileTemplate.vue?vue&type=template&id=a2c1ed60&lang=pug"
import script from "./CreateTextFileTemplate.vue?vue&type=script&lang=js"
export * from "./CreateTextFileTemplate.vue?vue&type=script&lang=js"
import style0 from "./CreateTextFileTemplate.vue?vue&type=style&index=0&id=a2c1ed60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports